import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Тепловоз ЧМЭ2 209';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Серия ЧМЭ2 №209</p>
                    <p>Построен в 1962 году в Чехославакии на заводе ЧДК-Прага</p>
                    <p>Конструктивная скорость - 70 км/ч</p>
                    <p>Служебный вес - 60т</p>
                    <p>Мощность - 750 л.с.</p>
                    <p>Средний маневровый тепловоз, разработанный на базе тепловоза T435.0 Чехословацких железных дорог.</p>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt056.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt057.jpg')} /></div>
            </div>
        </>
    );
}